import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-star\"><path d=\"M511.982298 779.001902l-300.936971 168.453894 67.268264-338.253155-253.282716-234.058154 342.501677-40.608789 144.449746-313.186875 144.48515 313.186875 342.643294 40.608789-253.211907 234.164368 67.268264 338.253154z\" fill=\"#FF4414\" p-id=\"3722\" data-spm-anchor-id=\"a313x.7781069.0.i24\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol